import { post } from "core/navigation"

const CREATE_ITEMS = [
  {
    id: "create-broadcast",
    label: "New Broadcast",
    keywords: ["compose", "email", "campaign", "newsletter"],
    shortcut: "n b",
    onSelect: (api, context) => {
      if (context.user.use_starting_points) {
        api.navigate("/editor/starting-points")
      } else {
        api.close()
        post("/campaigns/new/steps")
      }
    }
  },
  {
    id: "create-sequence",
    label: "New Email Sequence",
    keywords: ["course", "email", "drip", "nurture"],
    shortcut: "n e",
    visible: ({ user }) => user.canAddSequence,
    onSelect: api => api.navigate("/sequences/new")
  },
  {
    id: "create-visual-automation",
    label: "New Visual Automation",
    keywords: ["workflow", "trigger"],
    shortcut: "n a",
    onSelect: api => api.navigate("/automations/templates")
  },
  {
    id: "create-landing-page",
    label: "New Landing Page",
    keywords: ["page", "website"],
    shortcut: "n l",
    onSelect: api => api.navigate("/landing-pages/new")
  },
  {
    id: "create-form",
    label: "New Form",
    keywords: ["signup", "opt-in", "embed"],
    shortcut: "n f",
    onSelect: api => api.navigate("/forms/formats")
  },
  {
    id: "create-product",
    label: "New Product",
    keywords: ["commerce", "sell", "digital", "paid"],
    shortcut: "n p",
    onSelect: api => api.navigate("/products/new")
  },
  {
    id: "create-tip",
    label: "New Tip",
    keywords: ["tip jar", "donation", "support"],
    onSelect: api => api.navigate("/tips/new")
  }
]

const isVisible = (item, context) =>
  item.visible ? item.visible({ user: context.user }) : true

/**
 * @param {import("../types").CommandContext} context
 * @returns {import("../types").Shortcut[]}
 */
export function getCreateResourceShortcuts(context) {
  return CREATE_ITEMS.filter(
    item => item.shortcut && isVisible(item, context)
  ).map(item => ({
    shortcut: item.shortcut,
    onTrigger: api => item.onSelect(api, context)
  }))
}

/**
 * @type {import("../types").Provider}
 */
export function useCreateResourceProvider({ activePageId, context }) {
  // Root-only: a subpage is a focused mode, so create actions step aside for it.
  if (activePageId) return { commands: [], isLoading: false }

  const commands = CREATE_ITEMS.filter(item => isVisible(item, context)).map(
    item => ({
      id: item.id,
      label: item.label,
      icon: "plus",
      group: "Create",
      keywords: item.keywords,
      shortcut: item.shortcut,
      onSelect: api => item.onSelect(api, context)
    })
  )

  return { commands, isLoading: false }
}
